import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal, { ModalButton } from '../dm/Modal';
import { parseInvite } from './format';

// "+" in the server rail: paste an invite link to open its invite page
export default function JoinServerDialog({ onClose }) {
  const navigate = useNavigate();
  const [link, setLink] = useState('');
  const [error, setError] = useState('');

  const go = () => {
    const invite = parseInvite(link);
    if (!invite) { setError('That does not look like a BLOBL invite link.'); return; }
    onClose();
    navigate(`/invite/${invite.nodeId}/${invite.code}`);
  };

  return (
    <Modal
      title="Join a server"
      onClose={onClose}
      footer={<><ModalButton onClick={onClose}>Cancel</ModalButton><ModalButton primary disabled={!link.trim()} onClick={go}>Continue</ModalButton></>}
    >
      <div className="mb-3 text-sm leading-relaxed text-text-muted">
        Paste an invite link you got from someone on the server.
      </div>
      <input
        autoFocus
        value={link}
        onChange={e => { setLink(e.target.value); setError(''); }}
        onKeyDown={e => { if (e.key === 'Enter') go(); }}
        placeholder="https://blobl.de/invite/..."
        className="w-full rounded border border-solid border-border bg-surface px-3 py-2.5 font-body text-text outline-none placeholder:text-text-dim focus:border-purple"
      />
      {error && <div className="mt-2 text-xs text-red">{error}</div>}
    </Modal>
  );
}
